module.exports = __webpack_public_path__ + "media/images/views/candidate/request/candidate-050dcb94913dc459c6b636929239da7e.png";